import { useState } from 'react';
import gameIcon from '../../..//assets/fujiyamatap-icons/bottom-menu-buttons/game.webp';

export const GameRoute = () => {
    const [isRotating, setIsRotating] = useState(false);

    const handleTap = () => {
        if (isRotating) return;
        setIsRotating(true);
        setTimeout(() => {
            setIsRotating(false);
        }, 800);
    };

    return (
        <div className="flex flex-col h-screen bg-[#F8F7F7]" style={{
            paddingBottom: 'calc(env(safe-area-inset-bottom) + 8rem)'
        }}>

            <div className="mt-4">
                <div className="mt-12 flex flex-col items-center justify-center text-center">
                    <h2 className="text-xl font-medium text-gray-900 mb-4">Coming Soon</h2>
                    <p className="text-gray-600">
                        New games are on the way! Stay tuned for upcoming releases.
                    </p>
                    <div
                        className={`relative w-32 h-32 mt-8 cursor-pointer ${isRotating ? 'animate-rotate-once' : ''}`}
                        onClick={handleTap}
                    >
                        <img
                            src={gameIcon}
                            alt="Game Icon"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};